module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_plus-757d0932a67f51c27f672bc086399819.svg";